module.exports = __webpack_public_path__ + "static/media/eliane.17a14cb8.jpg";